import { paperGoodsIssueBusiness } from "api/bussiness/paper-material/paper-goods-issue";
import { paperGoodsReceiptBusiness } from "api/bussiness/paper-material/paper-goods-receipt";
import { paperInventoryBussiness } from "api/bussiness/paper-material/paper-inventory";
import { GetPapersInventory } from "api/models/request/paper-inventory/paper-inventory";
import {
  GetPaperGoodsIssue,
  GetPaperGoodsReceipt,
} from "api/models/request/paper-material/get-paper-material-inventory";
import { InventoryPagination } from "api/models/response/pagination";
import {
  createConditionalNaturalLanguageString,
  formatNumber,
} from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import {
  IPaperGoodsIssueProperties,
  PaperGoodsIssue,
} from "mobx-stores/_models/paper-inventory/paper-goods-issue/paper-goods-issue";
import {
  IPaperGoodsReceiptProperties,
  PaperGoodsReceipt,
} from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt";
import {
  IPaperInventoryProperties,
  PaperInventory,
} from "mobx-stores/_models/paper-inventory/paper-inventory";
import { PaperInventoryTab } from "pages/paper-inventory/paper-inventory";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";
export const PaperInventoryQueryParams = types
  .model({
    code: "",
    brand: "",
    specificationSize: "",
    rollNumber: "",
    type: "",
    gsm: "",
    showZeroQuantity: false,
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get natureLanguageString(): string {
      const map = new Map<string, any>([
        ["code", { label: "mã số", value: self.code }],
        ["brand", { label: "hiệu", value: self.brand }],
        [
          "specificationSize",
          { label: "khổ giấy", value: self.specificationSize },
        ],
        ["rollNumber", { label: "số cuồn", value: self.rollNumber }],
        ["type", { label: "loại giấy", value: self.type }],
        ["gsm", { label: "gsm", value: self.gsm }],
      ]);

      const result = createConditionalNaturalLanguageString(map);
      return result;
    },
  }));

export const ExcelQueryParams = types
  .model({
    issueDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    receiptDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    showZeroQuantity: false,
  })
  .actions(withSetPropAction);

export const PaperInventoryStore = types
  .model({
    openExportExcel: false,
    papersInventory: types.optional(types.array(PaperInventory), []),
    pagination: types.optional(PaginationStore, {}),
    queryParams: types.optional(PaperInventoryQueryParams, {}),
    excelParams: types.optional(ExcelQueryParams, {}),
    searchConditionAsNaturalLanguage: "",
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .views((self) => ({
    get groupedItemCount() {
      return self.papersInventory.reduce((acc, item) => {
        return acc + (item.groupedItems?.length || 0);
      }, 0);
    },
  }))
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.natureLanguageString;
      return `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      } Tổng số cuồn: ${formatNumber(self.groupedItemCount)} cuồn - Tổng trọng lượng: ${formatNumber(self.pagination.totalAmount, { maximumFractionDigits: 2 })} kg`;
    },
  }))
  .actions((self) => ({
    getPapersInventory: flow(function* getPapersInventory(
      request?: GetPapersInventory,
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            gsm: self.queryParams.gsm,
            type: self.queryParams.type,
            code: self.queryParams.code,
            brand: self.queryParams.brand,
            specificationSize: self.queryParams.specificationSize,
            rollNumber: self.queryParams.rollNumber,
            showZeroQuantity: self.queryParams.showZeroQuantity,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield paperInventoryBussiness.getPapersInventory(
          request,
        )) as InventoryPagination<IPaperInventoryProperties>;
        self.setProp("papersInventory", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
        self.pagination.setProp("totalAmount", res.totalAmount);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
export const PaperGoodsReceiptQueryParams = types
  .model({
    type: "",
    gsm: "",
    code: "",
    brand: "",
    specificationSize: "",
    rollNumber: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    showZeroQuantity: false,
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    getNatureLanguageString(): string {
      const map = new Map<string, any>([
        ["code", { label: "mã số", value: self.code }],
        ["brand", { label: "hiệu", value: self.brand }],
        [
          "specificationSize",
          { label: "khổ giấy", value: self.specificationSize },
        ],
        ["rollNumber", { label: "số cuồn", value: self.rollNumber }],
        ["type", { label: "loại giấy", value: self.type }],
        ["gsm", { label: "gsm", value: self.gsm }],
      ]);

      const result = createConditionalNaturalLanguageString(map);
      return result;
    },
  }));

export const PaperGoodsReceiptExcelQueryParams = types
  .model({
    receiptDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    showZeroQuantity: false,
  })
  .actions(withSetPropAction);

const PaperGoodsReceiptStore = types
  .model({
    paperGoodsReceipts: types.optional(types.array(PaperGoodsReceipt), []),
    paperGoodsReceiptDetail: types.maybeNull(PaperGoodsReceipt),
    pagination: types.optional(PaginationStore, {}),
    paperFilterValue: "",
    openNew: false,
    openEdit: false,
    openDelete: false,
    openExportExcel: false,
    queryParams: types.optional(PaperGoodsReceiptQueryParams, {}),
    excelParams: types.optional(PaperGoodsReceiptExcelQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getPaperGoodsReceipt: flow(function* getPaperGoodsReceipt(
      request?: GetPaperGoodsReceipt,
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromReceiptDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toReceiptDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            gsm: self.queryParams.gsm,
            type: self.queryParams.type,
            code: self.queryParams.code,
            brand: self.queryParams.brand,
            rollNumber: self.queryParams.rollNumber,
            specificationSize: self.queryParams.specificationSize,
            showZeroQuantity: self.queryParams.showZeroQuantity,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield paperGoodsReceiptBusiness.getLists(
          request,
        )) as InventoryPagination<IPaperGoodsReceiptProperties>;
        self.setProp("paperGoodsReceipts", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
        self.pagination.setProp("totalAmount", res.totalAmount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }))
  .views((self) => ({
    get searchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.getNatureLanguageString();
      const result = `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      } Tổng số cuồn: ${self.paperGoodsReceipts.length || 0} cuồn - Tổng trọng lượng: ${formatNumber(self.pagination.totalAmount, { maximumFractionDigits: 2 })} kg`;
      return result;
    },
  }));
export const PaperGoodsIssueQueryParams = types
  .model({
    type: "",
    gsm: "",
    code: "",
    brand: "",
    specificationSize: "",
    rollNumber: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    showZeroQuantity: false,
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    getNatureLanguageString(): string {
      const map = new Map<string, any>([
        ["code", { label: "mã số", value: self.code }],
        ["brand", { label: "hiệu", value: self.brand }],
        [
          "specificationSize",
          { label: "khổ giấy", value: self.specificationSize },
        ],
        ["rollNumber", { label: "số cuồn", value: self.rollNumber }],
        ["type", { label: "loại giấy", value: self.type }],
        ["gsm", { label: "gsm", value: self.gsm }],
      ]);

      const result = createConditionalNaturalLanguageString(map);
      return result;
    },
  }));

export const PaperGoodsIssueExcelQueryParams = types
  .model({
    issueDateRangeFilter: types.optional(DateRangeFilterStore, {}),
  })
  .actions(withSetPropAction);

const PaperGoodsIssueStore = types
  .model({
    paperGoodsIssues: types.optional(types.array(PaperGoodsIssue), []),
    paperGoodsIssueDetail: types.maybeNull(PaperGoodsIssue),
    pagination: types.optional(PaginationStore, {}),
    paperFilterValue: "",
    openNew: false,
    openEdit: false,
    openDelete: false,
    openExportExcel: false,
    queryParams: types.optional(PaperGoodsIssueQueryParams, {}),
    excelParams: types.optional(ExcelQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getPaperGoodsIssue: flow(function* getPaperGoodsIssue(
      request?: GetPaperGoodsIssue,
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromIssueDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toIssueDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            gsm: self.queryParams.gsm,
            type: self.queryParams.type,
            code: self.queryParams.code,
            brand: self.queryParams.brand,
            rollNumber: self.queryParams.rollNumber,
            specificationSize: self.queryParams.specificationSize,
            showZeroQuantity: self.queryParams.showZeroQuantity,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield paperGoodsIssueBusiness.getLists(
          request,
        )) as InventoryPagination<IPaperGoodsIssueProperties>;
        self.setProp("paperGoodsIssues", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
        self.pagination.setProp("totalAmount", res.totalAmount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }))
  .views((self) => ({
    get searchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.getNatureLanguageString();
      const result = `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      }  Tổng số cuồn: ${formatNumber(self.paperGoodsIssues.length)} cuồn - Tổng trọng lượng: ${formatNumber(self.pagination.totalAmount, { maximumFractionDigits: 2 })} kg`;
      return result;
    },
  }));

export const PaperInventoryManagement = types
  .model({
    paperInventoryStore: types.optional(PaperInventoryStore, {}),
    paperGoodsReceiptStore: types.optional(PaperGoodsReceiptStore, {}),
    paperGoodsIssueStore: types.optional(PaperGoodsIssueStore, {}),
    tabSelected: types.maybeNull(
      types.enumeration<PaperInventoryTab>(
        "PaperInventoryTab",
        Object.values(PaperInventoryTab),
      ),
    ),
  })
  .extend(withRootStore)
  .actions(withSetPropAction);
